// "HAS THE CLIENT PAID?" — asked when a charge is recorded, because in practice the
// partners usually record an invoice only once the client has paid it, and recording the
// invoice and then the payment as two separate steps asked for the same fact twice.
//
// THE QUESTION HAS NO DEFAULT, on purpose, and Save stays blocked until it is answered.
// The two wrong answers are not equally visible: an invoice wrongly left unpaid turns
// overdue and says so, but one wrongly marked paid credits the balance between the
// partners with money that never arrived — and nothing would ever flag it. So neither
// answer is pre-selected, the same rule the expense form's bearer question follows.
//
//   paid      the payment's fields appear (shared with the payment dialog), and the
//             server records the invoice and its payment in one transaction. The amount
//             follows the charge until edited — a smaller figure is a partial payment,
//             and the rest stays open to collect and is tracked for overdue as always.
//   not yet   exactly what recording always did: the charge alone, open to collect, and
//             the separate "רישום תשלום" action when the money arrives.
import he from '../i18n/he';
import { Select } from './Form';
import PaymentFields from './PaymentFields';

const t = he.collections.board;

export const PAID = 'paid';
export const NOT_PAID = 'not_paid';

// The payment as the form holds it: amount null means "the charge's full amount".
export const emptyPayment = () => ({ amount: null, payment_date: '', method: 'transfer' });
export const paymentAmount = (payment, chargeAmount) =>
  (payment.amount == null ? chargeAmount : payment.amount);

export default function PaidNowFields({ paidState, onPaidState, payment, onPayment, chargeAmount }) {
  const set = (key) => (e) => onPayment({ ...payment, [key]: e.target.value });
  return (
    <>
      <Select
        label={t.paidQuestion}
        value={paidState}
        onChange={(e) => onPaidState(e.target.value)}
        options={[
          { value: '', label: he.common.choose },
          { value: PAID, label: t.paidYes },
          { value: NOT_PAID, label: t.paidNo },
        ]}
      />
      {!paidState && <p className="field-note">{t.paidRequired}</p>}
      {paidState === PAID && (
        <>
          <PaymentFields
            form={{ ...payment, amount: paymentAmount(payment, chargeAmount) }}
            set={set}
          />
        </>
      )}
    </>
  );
}
